//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PasswordCard from '@/components/Password-Card'
import ScoreBar from '@/components/Score-Bar'
import TimeCard from '@/components/Time-Card'
import StatsTable from '@/components/Stats-Table'
import TimeTable from '@/components/Time-Table'

export default {
  name: 'Home',
  components: {
    PasswordCard,
    ScoreBar,
    TimeCard,
    StatsTable,
    TimeTable
  }
}
